import React from "react";

import { cn } from "../../utils/cn";

import type { ReactElement, ReactNode } from "react";

export interface SideBarProps {
  /** Whether the sidebar is currently open (visible). */
  isOpen: boolean;
  /** Width of the sidebar in pixels when open. */
  width?: number;
  className?: string;
  children: ReactNode;
}

/**
 * Collapsible container for a side panel.
 */
export function SideBar({ isOpen, width = 280, className, children }: SideBarProps): ReactElement {
  return (
    <div
      className={cn(
        "relative flex flex-col overflow-hidden bg-layer-layer0 transition-all duration-200 ease-in-out",
        "border-y-0 border-l-0 border-r border-solid border-gray-200 dark:border-gray-700",
        className
      )}
      style={{
        width: isOpen ? width : 0,
        opacity: isOpen ? 1 : 0,
      }}
    >
      <div className="flex size-full flex-col" style={{ width, minWidth: width }}>
        {children}
      </div>
    </div>
  );
}
